import { BASE_URL } from '../configs/config';

export interface UpdateOrderResult {
  ok: boolean;
  changed: boolean;
  written?: string[];
  suppressed?: {
    field: string;
    from: string;
    to: string;
  } | null;
}

export const updateOrderDoc = async (
  orderId: string,
  update: Record<string, any>,
  allowRegression?: boolean
): Promise<UpdateOrderResult> => {
  const res = await fetch(`${BASE_URL}updateOrderStatus`, {
    method: 'POST',
    cache: 'no-cache',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ orderId, update, allowRegression }),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok || data?.ok === false) {
    const error: any = new Error(data?.error || `HTTP_${res.status}`);
    error.code = data?.error;
    error.details = data?.rejected || data?.details;
    throw error;
  }

  return data as UpdateOrderResult;
};
